import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { COLOR_BLACK } from '../../constants/colors';
import { fontStyles } from '../../constants/styles';
import MinusSymbol from '../MinusSymbol';
import PlusSymbol from '../PlusSymbol';
import StyledFieldset from '../StyledFieldset';


const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${(props) => props.color};
`;

const Label = styled.span`
  ${fontStyles.bodySmall}
  min-width: 4em;
`;

/* order: 1 matches the input-position pattern inside StyledFieldset so
   the value sits between the [-] and [+] buttons. */
const ValueDisplay = styled.span`
  ${fontStyles.bodySmall}
  order: 1;
  min-width: 1.5em;
  padding: 0 0.5rem;
  text-align: center;
`;

/* Tighten the fieldset margin so the stepper sits flush in the booking bar. */
const TightFieldset = styled(StyledFieldset)`
  margin-bottom: 0;
`;


const InlineGuestStepper = ({
  color, decrementAriaLabel, decrementDisabled, incrementAriaLabel, incrementDisabled,
  labelDefault, labelId, onDecrement, onIncrement, value,
}) => (
  <Wrapper color={color}>
    <Label>
      <FormattedMessage defaultMessage={labelDefault} id={labelId} />
    </Label>
    <TightFieldset color={color}>
      <button
        aria-label={decrementAriaLabel}
        disabled={decrementDisabled}
        onClick={onDecrement}
        type="button"
      >
        <MinusSymbol color={color} width="2px" />
      </button>
      <button
        aria-label={incrementAriaLabel}
        disabled={incrementDisabled}
        onClick={onIncrement}
        type="button"
      >
        <PlusSymbol color={color} width="2px" />
      </button>
      <ValueDisplay aria-live="polite">
        <FormattedNumber value={value} />
      </ValueDisplay>
    </TightFieldset>
  </Wrapper>
);

InlineGuestStepper.propTypes = {
  color: PropTypes.string,
  decrementAriaLabel: PropTypes.string.isRequired,
  decrementDisabled: PropTypes.bool.isRequired,
  incrementAriaLabel: PropTypes.string.isRequired,
  incrementDisabled: PropTypes.bool.isRequired,
  labelDefault: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

InlineGuestStepper.defaultProps = {
  color: COLOR_BLACK,
};

export default InlineGuestStepper;
